'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var icons = require('@tempi/icons');
var styled = require('@emotion/styled');
var ui = require('../../../popup/v1/ui.js');
var ui$1 = require('../../../heading/ui.js');
var ui$2 = require('../../../paragraph/ui.js');
var ui$3 = require('../../../button/v2/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CheckoutSuccessPopup = ({
  open,
  setOpen
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(ui.PopupV1, __spreadProps(__spreadValues({
    show: open,
    onFinishClose: () => setOpen(false)
  }, {
    maskClosable: true,
    maskStyle: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    commonStyle: {
      borderRadius: 8,
      width: 334,
      backgroundColor: "#fff",
      height: 200,
      padding: {
        left: 32,
        right: 32,
        bottom: 32,
        top: 32
      }
    },
    position: "default"
  }), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(StyledIcon, {
        children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "SuccessColored",
          style: { fontSize: 120 }
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$1.Heading, {
        commonStyle: { margin: { top: 32 }, textAlign: "center" },
        text: "<h3>Th\xE0nh c\xF4ng!</h3>"
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$2.Paragraph, {
        commonStyle: { margin: { top: 12 }, textAlign: "center" },
        text: "T\u1EA1o \u0111\u01A1n h\xE0ng th\xE0nh c\xF4ng"
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$3.ButtonV2, __spreadProps(__spreadValues({}, {
        text: "<span>\u0110\xF3ng</span>",
        commonStyle: {
          margin: {
            top: 24
          }
        },
        buttonStyle: {
          backgroundColor: "#7367F0",
          color: "rgba(255, 255, 255, 1)",
          borderRadius: 4,
          height: 36,
          width: "100%"
        }
      }), {
        onClick: () => setOpen(false)
      }))
    ]
  }));
};
const StyledIcon = styled__default["default"].div`
  position: absolute;
  top: -60px;
  left: calc(50% - 60px);
`;

exports.CheckoutSuccessPopup = CheckoutSuccessPopup;
